<template>
  <div :class="book.status.toLowerCase()">
    <div class="tag">{{ value.label }}</div>
    <div class="more in-progress-reviews" v-if="book.stats.in_progress_reviews">
      {{ book.stats.in_progress_reviews | readers }} {{ (book.stats.in_progress_reviews < 2) ? "is" : "are" }}
      <span
        v-if="book.stats.looking_for_reviews"
      >reading,</span>
      <span v-else>reading</span>
    </div>
    <!-- <div
      class="more in-progress-reviews"
      v-if="book.stats.pending_approval_reviews"
    >{{ book.stats.pending_approval_reviews | reviews }} waiting approval</div>-->
    <div
      class="more pending-eta"
      v-if="book.status === 'PendingApproval'"
    >Approved within {{ estimatedApproval }}</div>
    <div
      class="more"
      v-else-if="user.is_late_unproven && book.stats.holding_unproven_reviews"
      :class="{'two-lines': book.stats.looking_for_reviews}"
    >
      <div v-if="book.stats.looking_for_reviews">
        Looking for {{ book.stats.looking_for_reviews | readers }}
        <div class="requests-on-hold">
          {{ book.stats.holding_unproven_reviews }} on hold
        </div>
      </div>
      <div v-else class="requests-on-hold">Requests on hold</div>
    </div>
    <div
      class="more"
      v-else-if="book.stats.looking_for_reviews "
    >
      Looking for {{ book.stats.looking_for_reviews | readers }}
    </div>
    <div
      class="more"
      v-else-if="book.status === 'Available' && (book.stats.looking_for_reviews < 1 && book.stats.in_progress_reviews < 1 && book.stats.total_reviews < 1 && !user.is_late_unproven)"
    >
      Click 'Get Reviewed' to find readers
    </div>
  </div>
</template>

<script>
import BookStatus from "../../values/BookStatus";
import { mapState } from "vuex";

export default {
  name: "Status",
  props: ["book"],
  data: function () {
    return {
      value: BookStatus[this.book.status],
    };
  },
  computed: {
    ...mapState({
      user: "user",
    }),
    estimatedApproval() {
      // console.log("est", this.book);

      this.book.estimated_available_at = this.book.estimated_available_at.replace(
        /-/g,
        "/"
      );
      const estimate = new Date(this.book.estimated_available_at);
      const now = new Date();
      // console.log("te", now.getTimezoneOffset());

      const diff =
        estimate.getTime() -
        now.getTime() -
        now.getTimezoneOffset() * 60 * 1000;
      let hours = Math.ceil(diff / 3600000);

      if (hours < 2) {
        hours = 2;
      }

      return hours + " hours";
    },
  },
  mounted() {
    //this.book.stats.in_progress_reviews = 2;
  },
};
</script>

<style scoped lang="scss">
.tag {
  float: left;
  display: block;
  margin-top: 8px;
  background: #ffe0b2;
  border-radius: 4px;
  padding: 0.5em 0.7em 0.4em 0.7em;
  font-size: 13pt;
  font-weight: 700;
  letter-spacing: 0px;
  color: #f57c00;
  font-family: "Source Sans Pro";
}
.more {
  float: left;
  display: block;
  margin-top: 13px;
  background: #fff;
  border-radius: 4px;
  padding: 0.2em 0em 0.2em 0.5em;
  font-size: 13pt;
  font-weight: 600;
  color: #f57c00;
  opacity: 0.8;
  font-family: "Source Sans Pro";
}
.two-lines{
  margin-top:3px !important;
}
.requests-on-hold {
  // color: $color-red;
  color: #bbb;
}
.more.pending-eta {
  color: lighten(#388e3c, 5%) !important;
}
.single .more {
  padding-top: 5px !important;
  font-size: 12pt !important;
}

.available .tag {
  background-color: lighten(#ffe0b2, 8%);
  border: 2px solid #ffe0b2;
  padding: 0.4em 0.7em 0.3em 0.7em;
  color: #f57c00;
}
.pendingapproval .tag {
  background: #dcedc8;
  color: #388e3c;
}
.changesrequested .tag {
  // background: #ffe6ad;
  // color: #b59505;
  background: $color-red;
  color: #ffe0b2;
}
.editing .tag {
  background: #daedff;
  color: #2196f3;
}

.holdingunproven .tag {
  // background: lighten($color-red,35%);
  // color: $color-red;
  background: #ececec ;
  color: #afafaf;
}
</style>